import styled from "styled-components";

// import { bgImage } from "assets/images";

export const SignupLayoutContainer = styled.div`
  display: flex;
  min-width: 100%;
  min-height: 100vh;
  font-family: "Geist", sans-serif;

  @media (max-width: 375px) {
    background-color: #f8f9fd;
    flex-direction: column;
  }

  .select-state svg {
    top: 10px;
  }

  .form-error {
    margin-top: 0;
  }

  .button-max-width {
    width: 42%;
  }

  /* Ensure all child elements inherit Geist font */
  * {
    font-family: "Geist", sans-serif;
  }
`;

export const Sidebar = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 2rem;
  background-size: 100%;
  background-repeat: no-repeat;
  height: 100vh;
  overflow-y: scroll;
  width: 100%;
  max-width: 300px;
  min-width: 300px;
  border-right: 1px solid #e9eaeb;

  @media (max-width: 992px) {
    display: none;
  }
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 2.5rem;

  img {
    width: "auto";
    height: 38px;
    object-fit: contain;
  }
`;

export const StepperContainer = styled.div`
  flex: 1;
`;

export const SignupStepContainer = styled.div`
  flex: 1;
  padding-bottom: 32px;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e9eaeb;
  margin-bottom: 32px;
`;

export const StepItem = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  position: relative;

  /* Add connecting line between steps, but not for the last item */
  &:not(:last-child)::after {
    content: "";
    position: absolute;
    left: 11px; /* Center the line with the 24px circle (24/2 - 1px = 11px) */
    top: 28px; /* 24px circle + 4px margin */
    width: 2px;
    height: 14px;
    background-color: ${({ isCompleted, isActive, isNextStepCompleted }) => {
      if (isCompleted || (isActive && isNextStepCompleted)) return "#2258F1";
      return "#E9EAEB";
    }};
    z-index: 1;
    border-radius: 8px;
  }

  margin-bottom: 22px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const StepNumber = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 600;
  margin-right: 0.75rem;
  flex-shrink: 0;
  position: relative;
  z-index: 2;

  /* Completed state - filled circle */
  ${({ isCompleted }) =>
    isCompleted &&
    `
    background-color: #2258F1;
    border: none;
    color: white;
  `}

  /* Active or inactive (but not completed) */
  ${({ isCompleted }) =>
    !isCompleted &&
    `
    background-color: transparent;
    border: 2px solid #2258F1;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #E9EAEB; /* default grey */
    }
  `}

  /* Inner circle blue when active (not completed) */
  ${({ isActive, isCompleted }) =>
    isActive &&
    !isCompleted &&
    `
    &::after {
      background-color: #2258F1;
    }
  `}
  /* Default/inactive border */
  ${({ isActive, isCompleted }) =>
    !isActive &&
    !isCompleted &&
    `
    border: 2px solid #E9EAEB;
    color: #414651;
  `}
  svg path {
    stroke: #fff;
  }
`;

export const StepContent = styled.div`
  flex: 1;
  padding-top: 2px; /* Align text with circle center */
`;

export const StepTitle = styled.h3`
  font-size: 14px;
  font-weight: 500;
  margin: 0;
  line-height: 20px;
  font-family: "Geist", sans-serif;

  /* Completed or active state */
  color: ${({ isCompleted, isActive }) =>
    isCompleted || isActive ? "#2258F1" : "#D5D7DA"};
`;

export const MainContent = styled.div`
  flex: 1;
  padding: 40px 30px;
  display: flex;
  gap: 12px;
  flex-direction: column;
  max-height: 100vh;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  img {
    width: "auto";
    height: 38px;
    object-fit: contain;
  }

  @media (min-width: 992px) {
    .surmountBetaImage {
      display: none;
      background: #f8f9fd;
    }
  }

  @media (max-width: 992px) {
    padding: 20px;
  }
`;

// Portfolio Building Section Styles
export const PortfolioBuildingSection = styled.div`
  padding: 1.5rem;
  border: 1px solid #e9eaeb;
  border-radius: 8px;
  background-color: #fafbfc;
`;

export const PortfolioBuildingTitle = styled.h4`
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 0.5rem 0;
  color: #414651;
  font-family: "Geist", sans-serif;
`;

export const PortfolioBuildingSubtitle = styled.p`
  font-size: 12px;
  font-weight: 400;
  margin: 0 0 1rem 0;
  color: #6b7280;
  font-family: "Geist", sans-serif;
`;

export const PortfolioStepsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  position: relative;
`;

export const PortfolioStepItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  position: relative;
  padding: 0.5rem 0;

  &:not(:last-child)::after {
    content: "";
    position: absolute;
    left: 9px;
    top: 28px;
    width: 2px;
    height: 16px;
    background-color: #e9eaeb;
  }

  ${({ isCompleted, isActive }) => {
    if (isCompleted || isActive) {
      return `
        &:not(:last-child)::after {
          background-color: #2258F1;
        }
      `;
    }
  }}
`;

export const PortfolioStepNumber = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
  font-family: "Geist", sans-serif;
  flex-shrink: 0;
  border-radius: 9999px;
  border: 1px solid var(--Colors-Border-border-secondary, #e9eaeb);
  background-color: white;
  color: #717680;
  position: relative;
  z-index: 1;

  ${({ isCompleted, isActive }) => {
    if (isCompleted) {
      return `
        background-color: #10B981;
        border-color: #10B981;
        color: white;
        &::before {
          content: "✓";
          font-size: 12px;
          font-weight: 700;
        }
      `;
    } else if (isActive) {
      return `
        background-color: #2258F1;
        border-color: #2258F1;
        color: white;
      `;
    }
  }}
`;

export const PortfolioStepText = styled.span`
  font-size: 12px;
  font-family: "Geist", sans-serif;
  color: #414651;

  ${({ isCompleted, isActive }) => {
    if (isCompleted) {
      return `
        font-weight: 600;
        color: #10B981;
      `;
    } else if (isActive) {
      return `font-weight: 600;`;
    } else {
      return `font-weight: 500; color: #D5D7DA;`;
    }
  }}
`;

export const ProgressBar = styled.div`
  width: 100%;
  height: 4px;
  background-color: #f3f4f6;
  border-radius: 2px;
  margin-bottom: 1rem;
  overflow: hidden;
`;

export const ProgressFill = styled.div`
  height: 100%;
  background: linear-gradient(90deg, #2258f1 0%, #4f46e5 100%);
  border-radius: 2px;
  transition: width 0.3s ease;
  width: ${({ progress }) => progress}%;
`;

export const StepContentArea = styled.div`
  width: 100%;
  height: 100%;
  background: #ffffff;

  @media (max-width: 375px) {
    flex-direction: column;
    padding: 13px 10px 20px;
    border-radius: 10px;
    border: 1px solid #e6e6e6;
  }
`;

export const StepWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 9px;
`;

export const StepIndicatorWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  width: 100%;
  max-width: 500px;

  @media (min-width: 992px) {
    display: none;
  }
`;

export const StepTextWrapper = styled.div`
  gap: 6px;
  display: flex;
  flex-direction: column;
`;

export const StepText = styled.h3`
  font-size: 18px;
  font-weight: 400;
  color: #048af5; // iOS/Apple blue
  margin: 0;
`;

export const ProgressCircle = styled.div`
  position: relative;
  width: 60px;
  height: 60px;

  .circle-bg {
    stroke: #e7effd;
  }

  .circle-fg {
    stroke: #048af5;
    transform: rotate(-90deg);
    transform-origin: center;
  }

  .progress-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 0.95rem;
    font-weight: 500;
    color: #048af5;
  }
`;

export const ContinueButton = styled.button`
  font-family: "Geist", sans-serif;
  font-weight: 500;
  font-size: 14px;
  border-radius: 8px;
  padding: 10px 14px;
  max-width: ${({ maxWidth }) => maxWidth || "270px"};
  cursor: pointer;
  transition: all 0.1s ease-in-out;
  border: 2px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 0 0 1px rgba(10, 13, 18, 0.18) inset,
    0 -2px 0 0 rgba(10, 13, 18, 0.05) inset, 0 1px 2px 0 rgba(10, 13, 18, 0.05);
  background: #2258f1;
  color: #fff;
  border: none;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
  }

  &:disabled {
    background: #2258f1 !important;
    color: #fff !important;
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

export const PreviousButton = styled.button`
  font-family: "Geist", sans-serif;
  font-weight: 500;
  font-size: 14px;
  border-radius: 8px;
  padding: 10px 14px;
  max-width: ${({ maxWidth }) => maxWidth || "270px"};
  color: #414651;
  background: transparent;
  border: 1px solid #d5d7da;
  max-width: ${({ maxWidth }) => maxWidth || "173px"};
  cursor: pointer;
  margin-top: auto;
  transition: all 0.1s ease-in-out;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(74, 144, 226, 0.3);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;
export const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 50px;
  margin-top: 20px;
`;

export const DisclaimerContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 13px;
  width: 100%;
  margin-top: 20px;

  @media (max-width: 375px) {
    flex-direction: column;
    justify-content: start;
    align-items: start;
  }

  .blue-color {
    color: #048af5;
  }
`;

export const ChoiceWrapper = styled.div`
  .input-form-field {
    background: ${({ theme }) => theme.input.bg.quaternary};
    border-radius: ${({ theme }) => theme.constants.BORDER_RADIUS_25};
    border: 1px solid ${({ theme }) => theme.card.border.quaternary};
    color: ${({ theme }) => theme.input.font.primary};

    &::placeholder {
      font-size: 12px;
      color: #717184;
      opacity: 1;
    }
  }
`;

export const TextAndButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: start;
  width: 100%;
`;

export const SkipButton = styled.button`
  background: none;
  border: none;
  color: #717184;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  padding: 0;
  &:hover {
    text-decoration: underline;
  }
`;
